import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import useMobile from "../../hooks/useMobile";
import DatePicker from "../input/DatePicker";
import DatePickerSwipe from "../input/DatePickerSwipe";

import CustomTags from "../input/CustomTabs";

import { isSameDay } from "../../pages/user/NotificationEvents";

const formatDateTime = (date: Date | null, timeString: string) => {
  if (date == null) return "";
  if (timeString == "" || timeString == null) return "";

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const [time, ampm] = timeString.split(/(?<=\d)(?=[a-zA-Z])/);
  let [hours, minutes] = time.split(":").map((str) => parseInt(str, 10));

  if (ampm === "pm" && hours < 12) hours += 12;

  const gmtOffsetMinutes = new Date().getTimezoneOffset();

  hours += gmtOffsetMinutes / 60;

  return `${year}-${month < 10 ? "0" + month : month}-${
    day < 10 ? "0" + day : day
  }T${hours}:${minutes < 10 ? "0" + minutes : minutes}:00Z`;
};

const formatNewTimeString = (date: Date) => {
  // Extract hours and minutes from the Date object
  const hours = date.getHours();
  const minutes = date.getMinutes();

  // Determine AM/PM
  const ampm = hours >= 12 ? "pm" : "am";

  // Convert hours from 24-hour format to 12-hour format
  const formattedHours = hours % 12 || 12;

  // Pad minutes with leading zero if necessary
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;

  // Construct the time string in "HH:MM AM/PM" format
  const formattedTime = `${formattedHours}:${formattedMinutes}${ampm}`;

  return formattedTime;
};

const DatePickerModal = ({
  isOpen,
  onClose,
  onSave,
  isLoading,
  availability,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSave: (start_time: string) => void;
  isLoading?: boolean;
  availability: any;
}) => {
  const isMobile = useMobile(600);

  const [timeframeDate, setTimeframeDate] = useState<Date | null>(null);

  const choices =
    availability.data?.data
      .filter((row: any) => {
        return isSameDay(new Date(row), timeframeDate);
      })
      .map((row: any) => {
        return formatNewTimeString(new Date(row));
      }) ?? [];

  const [choice, setChoice] = useState(0);

  const startTime = formatDateTime(timeframeDate, choices[choice]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent mx="10px">
        <ModalCloseButton />
        <ModalBody p="0">
          <Text variant="title" fontSize="2xl" fontWeight="500" mb="20px">
            Select date and time
          </Text>

          <Text variant="title" fontSize="md" fontWeight="500" mb="10px">
            Select date
          </Text>
          <Box>
            {isMobile ? (
              <DatePickerSwipe
                date={timeframeDate}
                setDate={setTimeframeDate}
              />
            ) : (
              <DatePicker
                daysPerPage={6}
                date={timeframeDate}
                setDate={setTimeframeDate}
              />
            )}
          </Box>

          <Text
            variant="title"
            fontSize="md"
            fontWeight="500"
            mb="10px"
            mt="20px"
          >
            Select time
          </Text>
          <CustomTags
            name="competitionLevel"
            value={choice}
            onChange={(v) => setChoice(v)}
            choices={choices}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            variant="heavy"
            size="sm"
            onClick={() => onSave(startTime)}
            isLoading={isLoading}
            isDisabled={choices.length == 0 || timeframeDate == null}
          >
            Book Time
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DatePickerModal;
